import React from 'react';
import api from '../../services/api';

const ImagePreview = ({ game, gameImages, onRemove }) => {
    const getImageUrl = (type) => {
        if (!gameImages[type]) return null;
        const base = api.defaults.baseURL || '';
        return `${base.replace(/\/$/, '')}/games/image/${game.gameId}/${type}`;
    };

    const renderScreenshot = (index) => {
        const key = `screenshot${index}`;
        const has = gameImages.screenshots && gameImages.screenshots[index - 1];
        return (
            <div className="admin-image-preview-item" key={key}>
                <img
                    src={has ? getImageUrl(key) : 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="150" height="100"><rect width="100%" height="100%" fill="%23e2e8f0"/><text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="%2394a3b8" font-family="Arial" font-size="12">No Screenshot</text></svg>'}
                    alt={`Screenshot ${index}`}
                    className="admin-image-preview-img"
                    onError={(e) => e.target.src = 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="150" height="100"><rect width="100%" height="100%" fill="%23e2e8f0"/><text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="%2394a3b8" font-family="Arial" font-size="12">No Screenshot</text></svg>'}
                />
                <span className="admin-image-preview-label">Screenshot {index}</span>
                {has && (
                    <button className="admin-image-remove-btn" onClick={() => onRemove(key)}>✕</button>
                )}
            </div>
        );
    };

    return (
        <div className="admin-images-section">
            <h4 className="admin-images-title">Current Images:</h4>
            <div className="admin-image-grid">
                <div className="admin-image-preview-item">
                    <img 
                        src={getImageUrl('banner') || 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="200" height="100"><rect width="100%" height="100%" fill="%23e2e8f0"/><text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="%2394a3b8" font-family="Arial" font-size="14">No Banner</text></svg>'} 
                        alt="Banner"
                        className="admin-image-preview-img"
                        onError={(e) => e.target.src = 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="200" height="100"><rect width="100%" height="100%" fill="%23e2e8f0"/><text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="%2394a3b8" font-family="Arial" font-size="14">No Banner</text></svg>'}
                    />
                    <span className="admin-image-preview-label">Banner</span>
                    {gameImages.banner && (
                        <button className="admin-image-remove-btn" onClick={() => onRemove('banner')}>✕</button>
                    )}
                </div>
                <div className="admin-image-preview-item">
                    <img 
                        src={getImageUrl('logo') || 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100"><rect width="100%" height="100%" fill="%23e2e8f0"/><text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="%2394a3b8" font-family="Arial" font-size="12">No Logo</text></svg>'} 
                        alt="Logo"
                        className="admin-image-preview-img"
                        onError={(e) => e.target.src = 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100"><rect width="100%" height="100%" fill="%23e2e8f0"/><text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="%2394a3b8" font-family="Arial" font-size="12">No Logo</text></svg>'}
                    />
                    <span className="admin-image-preview-label">Logo</span>
                    {gameImages.logo && (
                        <button className="admin-image-remove-btn" onClick={() => onRemove('logo')}>✕</button>
                    )}
                </div>
                {renderScreenshot(1)}
                {renderScreenshot(2)}
                {renderScreenshot(3)}
            </div>
        </div>
    );
};

export default ImagePreview;